import Vue from 'vue'

import {
    Button,
    NavBar,
    Icon,
    Tab,
    Tabs,
    Popup,
    Popover,
    Image as VanImage,
    Empty,
    ActionSheet,
    Overlay,
    Col,
    Row,
    Badge,
    Progress,
    Toast,
    List,
    Dialog,
    Notify,
    Circle,
    DropdownMenu,
    DropdownItem,
    ShareSheet,
    Sticky,
    NoticeBar,
    Field,
    Form,
    Picker,
    Uploader,
} from 'vant'

import 'vant/lib/button/style'
Vue.use(Button)
Vue.use(Uploader)
Vue.use(Picker)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Popup)
Vue.use(Popover)
Vue.use(VanImage)
Vue.use(Empty)
Vue.use(ActionSheet)
Vue.use(Overlay)
Vue.use(Col)
Vue.use(Row)
Vue.use(Badge)
Vue.use(Progress)
Vue.use(Toast)
Vue.use(List)
Vue.use(Form)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(Notify)
Vue.use(Circle)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ShareSheet)
Vue.use(Sticky);
Vue.use(NoticeBar);